export const generateShadows = (n) => {
  let value = '';
  for (let i = 0; i < n; i++) {
    value += `${Math.floor(Math.random() * 2000)}px ${Math.floor(Math.random() * 2000)}px #FFF`;
    if (i < n - 1) value += ', ';
  }
  return value;
};